import { Component, DestroyRef, Input, OnInit, WritableSignal, inject, signal } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Observable } from 'rxjs';

import { MenuItem, NavigationMenuService } from '@fcom/common';
import {
  CmsContent,
  CmsContentType,
  CmsFormType,
  CmsTaxonomyGeneral,
  CmsTemplate,
  CmsViewType,
  PageViewType,
} from '@fcom/core-api';
import { LoaderTheme } from '@fcom/ui-components';

@Component({
  selector: 'cms-bluewings-main-page',
  templateUrl: './cms-bluewings-main-page.component.html',
  styleUrls: ['./cms-bluewings-main-page.component.scss'],
  animations: [
    trigger('fadeIn', [state('void', style({ opacity: 0 })), transition(':enter', [animate('0.5s ease-in')])]),
  ],
  standalone: false,
})
export class CmsBluewingsMainPageComponent implements OnInit {
  private navigationMenuService = inject(NavigationMenuService);
  private destroyRef = inject(DestroyRef);

  @Input()
  template$: Observable<CmsTemplate>;

  @Input()
  hasContent = false;

  activeNaviSection$: Observable<MenuItem>;
  // use this to toggle sidebar nav before new layout goes live.
  removeNav: WritableSignal<boolean> = signal(false);
  titleAsH1: WritableSignal<boolean> = signal<boolean>(false);

  public readonly DOCTYPE: typeof CmsContentType = CmsContentType;
  public readonly VIEWTYPE: typeof CmsViewType = CmsViewType;
  public readonly FORMTYPE: typeof CmsFormType = CmsFormType;
  public readonly PAGETYPE: typeof PageViewType = PageViewType;
  readonly LoaderTheme = LoaderTheme;

  constructor() {
    this.activeNaviSection$ = this.navigationMenuService.activeNaviSection;
  }

  ngOnInit(): void {
    this.template$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((template: CmsTemplate): void => {
      this.removeNav.set(
        template?.header?.some((item: CmsContent): boolean =>
          item?.subjectTaxonomyTags?.includes(CmsTaxonomyGeneral.CONTENT_TOGGLE_FULL_WIDTH)
        )
      );
      this.titleAsH1.set(
        template?.header?.some((item: CmsContent): boolean =>
          item?.subjectTaxonomyTags?.includes(CmsTaxonomyGeneral.HEADER_LEVEL_1)
        )
      );
    });
  }
}
